// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../registry.npmmirror.com+css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/cjs.js!./remixicon.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../registry.npmmirror.com+vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("d20ebd24", content, true, {});